import List from './List.vue'
import Create from './Create.vue'
import Edit from './AdvisoryRiskAndQuality/Edit.vue'
import ARQReviewerAnswer from './AdvisoryRiskAndQuality/Answer.vue'

export default [
  {
    path: 'reviews/list/:id',
    name: 'Reviews',
    component: List,
    meta: {
      profiles: ['user', 'admin', 'adminTi', 'audit']
    }
  },
  {
    path: 'reviews/create',
    name: 'Create Review',
    component: Create,
    meta: {
      profiles: ['admin']
    }
  },
  {
    path: 'reviews/:id',
    name: 'Review',
    component: ARQReviewerAnswer,
    meta: {
      profiles: ['user', 'admin', 'adminTi', 'audit']
    }
  },
  {
    path: 'reviews/details/:id',
    name: 'Review Details',
    component: Edit,
    meta: {
      profiles: ['admin']
    }
  }
]
